import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, IconButton, Tooltip } from '@mui/material';

export default function SortablePin({
  id,
  label,
  children,
}: {
  id: string;
  label: string;
  children: (handle: React.ReactNode) => React.ReactNode;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  return (
    <Box
      ref={setNodeRef}
      sx={{
        position: 'relative',
        minWidth: 0,
        '& .pin-drag-handle': { opacity: 0, transition: 'opacity 120ms ease' },
        '&:hover .pin-drag-handle, &:focus-within .pin-drag-handle': { opacity: 1 },
        '@media (hover: none)': { '& .pin-drag-handle': { opacity: 1 } },
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 2 : undefined,
        opacity: isDragging ? 0.7 : 1,
      }}
    >
      {children(
        <Tooltip title="Drag to reorder">
          <IconButton
            className="pin-drag-handle"
            {...attributes}
            {...listeners}
            aria-label={`Reorder ${label}`}
            size="small"
            sx={{ color: 'inherit', cursor: 'grab', touchAction: 'none', '&:active': { cursor: 'grabbing' } }}
          >
            <DragIndicatorIcon sx={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>,
      )}
    </Box>
  );
}
